import { RS_COLOR_BLACK, RS_COLOR_BLACK_T70, RS_COLOR_BLACK_T50, RS_COLOR_GREY_10, RS_COLOR_WHITE, RS_COLOR_WHITE_T70, RS_COLOR_WHITE_T50, RS_COLOR_GREY_90 } from '@rescui/colors';

function typographyLight(el) {
  el.style.setProperty('--rs-typography-color-hard', RS_COLOR_BLACK);
  el.style.setProperty('--rs-typography-color-average', RS_COLOR_BLACK_T70);
  el.style.setProperty('--rs-typography-color-pale', RS_COLOR_BLACK_T50);
  el.style.setProperty('--rs-typography-pre-color', RS_COLOR_BLACK);
  el.style.setProperty('--rs-typography-pre-bg-color', RS_COLOR_GREY_10);
  el.style.setProperty('--rs-typography-text-link-hover-color', RS_COLOR_WHITE);
}

function typographyDark(el) {
  el.style.setProperty('--rs-typography-color-hard', RS_COLOR_WHITE);
  el.style.setProperty('--rs-typography-color-average', RS_COLOR_WHITE_T70);
  el.style.setProperty('--rs-typography-color-pale', RS_COLOR_WHITE_T50);
  el.style.setProperty('--rs-typography-pre-color', RS_COLOR_WHITE_T70);
  el.style.setProperty('--rs-typography-pre-bg-color', RS_COLOR_GREY_90);
  el.style.setProperty('--rs-typography-text-link-hover-color', RS_COLOR_BLACK);
}

function resetTypographyColorVariables(el) {
  el.style.setProperty('--rs-typography-color-hard', null);
  el.style.setProperty('--rs-typography-color-average', null);
  el.style.setProperty('--rs-typography-color-pale', null);
  el.style.setProperty('--rs-typography-pre-color', null);
  el.style.setProperty('--rs-typography-pre-bg-color', null);
  el.style.setProperty('--rs-typography-text-link-hover-color', null);
}

export { resetTypographyColorVariables, typographyDark, typographyLight };
